module.exports = __webpack_public_path__ + "img/tips.c76bed2c.svg";